module.exports = __webpack_public_path__ + "static/media/auth_illustration.da8214c2.png";